module.exports = __webpack_public_path__ + "img/hero_portrait_demon-hunter_female.7995f193.png";